import { useQuery } from '@tanstack/react-query';
import { featuresService, FeaturesConfig } from '@/services/subscriptions';

export function useFeatures() {
  return useQuery<FeaturesConfig>({
    queryKey: ['features'],
    queryFn: featuresService.get,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: false,
  });
}
